import { string } from 'yup';

export const passwordSchema = string()
  .required('Please fill out this field')
  .min(6, 'Must be at least 6 characters')
  .max(50, 'No more than 50 characters')
  .matches(/^(?=.*[0-9])*[a-zA-Z0-9!@#$%^&*]{6,50}$/, 'Need stronger password');
